import { IRateContract } from 'types';
import { IExternalHedge } from 'types/externalHedges';

export const isExternalHedge = (
  record: IRateContract | IExternalHedge
): record is IExternalHedge =>
  (record as IExternalHedge).counterpartyName !== undefined;
